module.exports = __webpack_public_path__ + "static/twitter-0525094461cf5e8e03e62c5e665f0cda.png";